import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-[#0B0B0B] border-t border-[#1C1C1C] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center space-y-6">
          {/* Logo */}
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="text-4xl font-light text-[#F5F5F5] tracking-wider"
            style={{ fontFamily: 'Playfair Display, serif', fontStyle: 'italic' }}
            data-testid="footer-logo"
          >
            R
          </motion.div>

          {/* Artistic Phrase */}
          <p
            className="text-lg text-[#9CA3AF] tracking-wide text-center"
            style={{ fontFamily: 'Playfair Display, serif', fontStyle: 'italic' }}
          >
            Arte permanente, calidad excepcional
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            <motion.a
              href="https://www.instagram.com/ramiro_alfonsot/"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              className="text-[#9CA3AF] hover:text-[#FFFFFF] transition-colors"
              data-testid="footer-instagram"
            >
              <Instagram size={24} />
            </motion.a>

            <motion.a
              href={`https://wa.me/573227613983?text=${encodeURIComponent('Hola Ramiro, quiero consultar sobre mi proyecto de tatuaje.')}`}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              className="text-[#9CA3AF] hover:text-[#FFFFFF] transition-colors"
              data-testid="footer-whatsapp"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
              </svg>
            </motion.a>
          </div>

          {/* Copyright */}
          <div className="w-full border-t border-[#1C1C1C] pt-6 text-center">
            <p className="text-sm text-[#9CA3AF] tracking-wide">
              © {new Date().getFullYear()} Ramiro Tattoo. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
